import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import Modal from 'react-bootstrap/lib/Modal';
import { useDispatch, useSelector } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';

import messages from '../../../../locale/messages';
import { closeSmtpSetupModal } from '../../../../actions/siteadmin/modalActions';
import s from './SMTPModal.css';
import SMTPForm from '../SMTPForm/SMTPForm';

function SMTPModal({ intl, paginationData, currentPage }) {
  const dispatch = useDispatch();
  const smtpSetupModal = useSelector(state => state?.adminModalStatus?.smtpSetupModal);
  const smtpSetupModalType = useSelector(state => state?.adminModalStatus?.smtpSetupModalType || 'add');

  const handleClose = () => {
    dispatch(closeSmtpSetupModal());
  };

  return (
    <Modal show={smtpSetupModal} onHide={handleClose} className={'adminModal'}>
      <Modal.Header closeButton>
        <Modal.Title>
          {smtpSetupModalType === 'add' ? (
            <FormattedMessage {...messages.addLabel} />
          ) : (
            <FormattedMessage {...messages.editLabel} />
          )}{' '}
          <FormattedMessage {...messages.smtpSetupLabel} />
        </Modal.Title>
      </Modal.Header>
      <Modal.Body bsClass={s.logInModalBody}>
        <div className={cx(s.modalRoot, s.modalBorderBottom)}>
          <SMTPForm paginationData={paginationData} currentPage={currentPage} />
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default injectIntl(withStyles(s)(SMTPModal));
